// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__385l-","footer":"ModalInfo_footer__1DI9f"};